export const TAILWIND_COLORS = [
  { label: "global:shared.colors.slate", value: "slate", hex: "#94a3b8" },
  { label: "global:shared.colors.gray", value: "gray", hex: "#9ca3af" },
  { label: "global:shared.colors.zinc", value: "zinc", hex: "#a1a1aa" },
  { label: "global:shared.colors.neutral", value: "neutral", hex: "#a3a3a3" },
  { label: "global:shared.colors.stone", value: "stone", hex: "#a8a29e" },
  { label: "global:shared.colors.red", value: "red", hex: "#f87171" },
  { label: "global:shared.colors.orange", value: "orange", hex: "#fb923c" },
  { label: "global:shared.colors.amber", value: "amber", hex: "#fbbf24" },
  { label: "global:shared.colors.yellow", value: "yellow", hex: "#facc15" },
  { label: "global:shared.colors.lime", value: "lime", hex: "#a3e635" },
  { label: "global:shared.colors.green", value: "green", hex: "#4ade80" },
  { label: "global:shared.colors.emerald", value: "emerald", hex: "#34d399" },
  { label: "global:shared.colors.teal", value: "teal", hex: "#2dd4bf" },
  { label: "global:shared.colors.cyan", value: "cyan", hex: "#22d3ee" },
  { label: "global:shared.colors.sky", value: "sky", hex: "#38bdf8" },
  { label: "global:shared.colors.blue", value: "blue", hex: "#60a5fa" },
  { label: "global:shared.colors.indigo", value: "indigo", hex: "#818cf8" },
  { label: "global:shared.colors.violet", value: "violet", hex: "#a78bfa" },
  { label: "global:shared.colors.purple", value: "purple", hex: "#c084fc" },
  { label: "global:shared.colors.fuchsia", value: "fuchsia", hex: "#e879f9" },
  { label: "global:shared.colors.pink", value: "pink", hex: "#f472b6" },
  { label: "global:shared.colors.rose", value: "rose", hex: "#fb7185" },
];

const NEW_THEME = {
  primary: {
    "50": "#FAF7F2",
    "100": "#F7F0E6",
    "200": "#E8D5C1",
    "300": "#DBBCA0",
    "400": "#C28565",
    "500": "#A75035",
    "600": "#96432C",
    "700": "#7D311E",
    "800": "#632213",
    "900": "#4A150A",
    "950": "#300B04",
  },
  secondary: {
    "50": "#FCFAF2",
    "100": "#F7F3E1",
    "200": "#EDE1B9",
    "300": "#E0CB90",
    "400": "#CCA24E",
    "500": "#B47614",
    "600": "#A36610",
    "700": "#874D0B",
    "800": "#6E3B08",
    "900": "#522704",
    "950": "#361602",
  },
  accent: {
    "50": "#FAF2F8",
    "100": "#F2E4EE",
    "200": "#E0BFD5",
    "300": "#CC9BB9",
    "400": "#A86388",
    "500": "#823558",
    "600": "#752B4B",
    "700": "#611E39",
    "800": "#4F142A",
    "900": "#3B0B1B",
    "950": "#26050E",
  },
  base: {
    "50": "#FCFBF9",
    "100": "#F7F5F0",
    "200": "#EFEBE1",
    "300": "#E2DAC8",
    "400": "#D1C5AD",
    "500": "#C2B294",
    "600": "#A69273",
    "700": "#857356",
    "800": "#6B5A42",
    "900": "#524330",
    "950": "#362B1E",
  },
  content: {
    "50": "#F5F4F2",
    "100": "#EDECE8",
    "200": "#D1CEC7",
    "300": "#B8B3A9",
    "400": "#80796F",
    "500": "#4A443C",
    "600": "#423A30",
    "700": "#382D22",
    "800": "#2B1F15",
    "900": "#21150C",
    "950": "#140A05",
  },
  ghost: {
    "50": "#FDFAF7",
    "100": "#F8F3EC",
    "200": "#EAE0D3",
    "300": "#D9C9B7",
    "400": "#C4AF98",
    "500": "#AE957B",
    "600": "#8C7359",
    "700": "#705A45",
    "800": "#594534",
    "900": "#423224",
    "950": "#291E13",
  },
  info: {
    "50": "#F5FDFF",
    "100": "#E8F9FF",
    "200": "#C7EDFC",
    "300": "#A5DFFA",
    "400": "#63BEF7",
    "500": "#2196F3",
    "600": "#1D7FDB",
    "700": "#1261B5",
    "800": "#0C4691",
    "900": "#07306E",
    "950": "#031B47",
  },
  success: {
    "50": "#F2FAF6",
    "100": "#E9F7EF",
    "200": "#CAEBD7",
    "300": "#ADE0BD",
    "400": "#77C786",
    "500": "#4CAF50",
    "600": "#3E9E41",
    "700": "#2A852D",
    "800": "#1B691E",
    "900": "#0F4F10",
    "950": "#063307",
  },
  warning: {
    "50": "#FFFBF2",
    "100": "#FCF5E3",
    "200": "#FAE4BB",
    "300": "#F7D194",
    "400": "#F2A44B",
    "500": "#ED6C02",
    "600": "#D65E02",
    "700": "#B34802",
    "800": "#8F3501",
    "900": "#6B2400",
    "950": "#451400",
  },
  error: {
    "50": "#FCF7F2",
    "100": "#FAEFE6",
    "200": "#F5D8C6",
    "300": "#EDBAA4",
    "400": "#E07765",
    "500": "#D32F2F",
    "600": "#BF2626",
    "700": "#9E1919",
    "800": "#801111",
    "900": "#5E0909",
    "950": "#3D0404",
  },
};

export const colors = NEW_THEME;

export const CHART_COLORS = [
  colors.primary[400], // Soft primary
  colors.accent[400], // Soft accent
  colors.secondary[400], // Soft secondary
  colors.content[400], // Soft content
  colors.primary[500], // Medium primary
  colors.accent[500], // Medium accent
  colors.secondary[500], // Medium secondary
  colors.content[500], // Medium content
  colors.primary[600], // Deep primary
  colors.accent[600], // Deep accent
  colors.secondary[600], // Deep secondary
  colors.content[600], // Deep content
];
